import { render, staticRenderFns } from "./SourceLookupGrammar.vue?vue&type=template&id=739cc61f&"
import script from "./SourceLookupGrammar.vue?vue&type=script&lang=js&"
export * from "./SourceLookupGrammar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports